var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8233 13.4627C32.5766 13.2134 31.33 13.0472 30.0003 13.0472C26.759 13.0472 23.6839 13.9613 21.0244 15.6234L17.0352 13.6289C19.7778 11.4682 22.9359 10.0555 26.3434 9.47375C26.6759 9.39064 27.0083 9.39064 27.3407 9.30754L30.0003 0L32.6598 9.22444L33.8233 13.4627Z",
    fill: "#2E58A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1137 16.2055C17.0387 18.4493 14.7116 21.6072 13.6312 25.3469L9.39258 26.5934C9.97435 23.2693 11.3041 20.0283 13.3818 17.369C13.6312 17.1197 13.7974 16.8704 14.0467 16.6211L11.7196 11.9673L16.2907 14.2942L20.1137 16.2055Z",
    fill: "#122164"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5415 38.975L13.5469 42.964C11.386 40.2216 9.97315 37.0637 9.39138 33.6564C9.30827 33.324 9.30827 32.9916 9.22516 32.6592L0 29.9999L9.22516 27.4237L13.3806 26.2603C13.1313 27.5068 12.9651 28.7533 12.9651 30.083C13.0482 33.324 13.9624 36.3157 15.5415 38.975Z",
    fill: "#12491D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5071 50.6091C23.1827 50.0273 19.9414 48.6977 17.2819 46.6201C17.0326 46.4539 16.7832 46.2046 16.5339 45.9553L11.9629 48.2822L14.29 43.7115L16.2015 39.8057C18.3623 42.8805 21.6036 45.2074 25.3435 46.2877L26.5071 50.6091Z",
    fill: "#237D26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8984 46.4545C40.1558 48.6152 36.9976 50.028 33.5901 50.6097C33.2577 50.6928 32.9252 50.6928 32.5928 50.7759L30.0164 60.0003L27.3569 50.7759L26.1934 46.5376C27.44 46.87 28.6866 46.9531 30.0164 46.9531C33.3408 46.9531 36.3327 46.039 38.9922 44.377L42.8984 46.4545Z",
    fill: "#2DA131"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9553 43.5462L48.2824 48.1169L43.7113 45.79L39.8052 43.8786C42.8802 41.7179 45.2073 38.4769 46.2877 34.7373L50.6094 33.4907C50.0277 36.8148 48.6979 40.0559 46.6202 42.7152C46.3708 42.9645 46.2046 43.2969 45.9553 43.5462Z",
    fill: "#41AA54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 30.0001L50.7749 32.6594L46.5363 33.906C46.8688 32.6594 46.9519 31.3298 46.9519 30.0001C46.9519 26.7591 46.0377 23.6843 44.3755 21.1081L46.3701 17.1191C48.531 19.8615 49.9438 23.0195 50.5256 26.4267C50.6087 26.7591 50.6087 27.0915 50.6918 27.4239L60.0001 30.0001Z",
    fill: "#01A0C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1113 11.8011L45.7842 16.3718L43.8727 20.1945C41.7118 17.0366 38.4706 14.7097 34.6475 13.6294L33.4009 9.39111C36.8084 9.97283 39.9665 11.3025 42.626 13.3801C42.8754 13.6294 43.1247 13.7956 43.374 14.0449L48.1113 11.8011Z",
    fill: "#4FA0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.543760082ce53babc0cc92c6e8ca2364.svg";
export { ForwardRef as ReactComponent };